import bridge from '@vkontakte/vk-bridge';

import api from './api';
import { getSHA256Hash } from '../utils/getSHA256Hash';

const getPrediction = (groups: {[key: string]: any}, userId: number) => {
  return api('predictions',{ groups: groups, prediction_user_id: userId });
};


async function updateHasUserAgreed(prediction_user_id: number, params: any, has_user_agreed: boolean) {
  const data = {
    prediction_user_id: prediction_user_id,
    params: params,
    has_user_agreed: has_user_agreed
  };

  const checkSum = await getSHA256Hash(JSON.stringify(data));

  bridge.send('VKWebAppCreateHash', { payload:  checkSum })
    .then((response) => {
      return api(
        'predictions/update_has_user_agreed',
        {
          data: data,
          //@ts-ignore
          hash: response.sign,
          ts: response.ts,
        },
        { method: 'PUT' }
      );
    });
}

const predictionsApi = { getPrediction, updateHasUserAgreed };

export default predictionsApi;
